import React, { ReactNode, useEffect } from 'react';
import cookies from 'js-cookie';
import { cookieNames, Loader } from '@monorepo/common';

import { useGetUserInfoQuery } from '../../services/serviceUserInfo';
import { getJobsAccountLoginUrl } from '../../utils/jobsAccountAuth';

interface IJobsAccountGuardProps {
  children: ReactNode;
}

export const JobsAccountGuard = ({ children }: IJobsAccountGuardProps) => {
  const hasToken = Boolean(cookies.get(cookieNames.bevnet_token));
  const {
    data,
    error,
    isLoading,
    isFetching,
  } = useGetUserInfoQuery(undefined, {
    skip: !hasToken,
  });

  const authenticationComplete = hasToken && !isLoading && !isFetching;
  const isAuthenticated = authenticationComplete
    && !error
    && Boolean(data?.isLoggedIn);
  const shouldRedirect = !hasToken
    || (authenticationComplete && (!data?.isLoggedIn || Boolean(error)));

  useEffect(() => {
    if (shouldRedirect) {
      window.location.href = getJobsAccountLoginUrl(window.location.href);
    }
  }, [shouldRedirect]);

  if (!isAuthenticated) {
    return <Loader isShow />;
  }

  return <>{children}</>;
};

export default JobsAccountGuard;
